import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { pathNames } from '../utilities/routing-path-utils';
import { AppComponentEventsService } from '../events/app-component-events.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  constructor(private authenticationService: AuthenticationService, private router: Router, private appComponentEventService: AppComponentEventsService) { }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
   if (this.authenticationService.isAuthenticated()) return true;
    else {
      this.router.navigate(['/' + pathNames.loginPath]);

      return false;
    }
  }
}